import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Самодеятельный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Путешествие с использованием активных способов передвижения, организуемых туристом
                        самодеятельно</p>
                    <p>Как правило, данный туризм характеризуется активными способами передвижения.</p>
                    <p>При этом маршрут, состав туристкой группы, снаряжение, обеспечение продуктами питания, способов
                        передвижения и финансирование организуется самостоятельно, либо при поддержке туристскими
                        клубами, секциями, общественными организациями.</p>
                    <p className="sub">Самодеятельный туризм подразделяется.</p>
                    <div className="two-col-cell">
                        <ol>
                            <li>По форме проведения, прогулки, походы, путешествия, слеты, экспедиции, соревнования.
                            </li>
                            <li>По видам маршрутов, пешеходные, лыжные, горные, водные, спелео, альпинизм, велосипедные
                                маршруты, мотоциклетные, воздушные, комбинированные.
                            </li>
                            <li>По сложности: категорийные и некатегорийные маршруты.</li>
                            <li>По организационным принадлежностям: туристские клубы станции юных туристов, туристские
                                секции, спортивные организации.
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </>
    );
}